import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

import { hasDeliveryShiftsQueryOptions } from "@/lib/shifts";
import { useCartStore } from "@/components/cart/store";
import { OrderTypes } from "@/lib/supabase/enums";

// Whether the business offers delivery at all. Defaults to `true` while the
// query is loading (or on error) so we never wrongly hide delivery for a
// business that offers it, nor coerce its cart to pickup during load.
export const useHasDeliveryShifts = () => {
  const { data } = useQuery(hasDeliveryShiftsQueryOptions());
  return data?.hasDeliveryShifts ?? true;
};

// Keeps the selected order type valid: when the business has no delivery shifts
// the cart falls back to pickup (take away) by default.
export const useEnsureValidOrderType = () => {
  const hasDeliveryShifts = useHasDeliveryShifts();
  const orderType = useCartStore((state) => state.cart.orderType);
  const setOrderType = useCartStore((state) => state.setOrderType);

  useEffect(() => {
    if (!hasDeliveryShifts && orderType === OrderTypes.delivery) {
      setOrderType(OrderTypes.pickup);
    }
  }, [hasDeliveryShifts, orderType, setOrderType]);
};
